import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useState } from "react";

import { Button, Col, Divider, Row, Tabs } from "antd";
import { TypeViagem } from "../../../../../Models/Domain/Viagem/Viagem";

import Titulo from "../../../../../Models/Financeiro/Titulo/Titulo";
// import TituloDrawer from "../../../../../Components/Populados/Financeiro/Titulo/TituloDrawer";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { useRequerPermissoes } from "../../../../../Hooks/useRequerPermissoes";
import ViagemFechamentoScreen from "../../../../../Components/Populados/Viagem/ViagemFinanceiroScreen";
import Permissoes from "../../../../../Constants/Permissoes";
import Arquivos from "../Arquivos";
import CadastroDeViagens from "../Cadastro";
import InscricoesDaViagem from "../Inscricoes";
import { ReciboDaViagemScreen } from "@/Components/Populados/Viagem/Recibos/RecibosDaViagemScreen";

type Aba = ( 
    | "editar" 
    | "arquivos" 
    | "inscricoes" 
    | "fechamento"
 );

export const DetalhesDaViagem: React.FC<{
    viagem: TypeViagem;
    voltar?: () => any;
    abaInicial?: Aba;
}> = (props) => {

    const [viagem, setViagem] = useState<TypeViagem>(props.viagem)

    const navigate = useNavigate();
    const requerPermissoes = useRequerPermissoes();
    const [params] = useSearchParams();
    const abaInicialQuery = params.get("tela_viagem_aba_inicial");

    const [fichaFinanceira, setFichaFinanceira] = useState<{
        open: boolean;
        defaultValues: Partial<Titulo<any>>;
    }>({
        open: false,
        defaultValues: {},
    });

    return (
        <div>
            {props.voltar && (
                <React.Fragment>
                    <Row>
                        <Col xs={24}>
                            <Button style={{ padding: 0 }} type="link" icon={<ArrowLeftOutlined />} onClick={props.voltar}>
                                Voltar
                            </Button>
                        </Col>
                    </Row>

                    <Divider style={{ margin: ".5em" }} />
                </React.Fragment>
            )}

            <Tabs
                defaultActiveKey={props.abaInicial ?? abaInicialQuery ?? undefined}
                items={[
                    requerPermissoes?.todas(Permissoes.AtualizarViagem) && 
                    {
                        key: "editar" as Aba,
                        label: "Editar",
                        children: <CadastroDeViagens viagemEmAlteracao={viagem} depoisDeFinalizar={(v) => {
                            if(v) setViagem(v);
                        }} />,
                    },
                    requerPermissoes?.todas() && 
                    {
                        key: "arquivos" as Aba,
                        label: "Arquivos adicionais",
                        children: <Arquivos viagem={viagem}/>,
                    },

                    requerPermissoes?.alguma(Permissoes.CriarInscricaoDaViagem, Permissoes.ListarInscricoesDaViagem, Permissoes.Viagem_Inscricao_AlterarStatus) && 
                    {
                        key: "inscricoes" as Aba,
                        label: "Inscrições",
                        children: <InscricoesDaViagem privilegio="administrador" viagem={viagem} ocultarDescricao/>,
                    },
                    requerPermissoes?.alguma(Permissoes.FinanceiroTituloListar) && 
                    {
                        key: "fechamento" as Aba,
                        label: "Faturamento",
                        children: (
                            <ViagemFechamentoScreen viagem={viagem} />
                        ),
                    },
                ].filter((v) => v !== false)}
            />

            {/* <TituloDrawer
                destroyOnClose={true}
                open={fichaFinanceira.open}
                defaultValues={fichaFinanceira.defaultValues}
                title={((): React.ReactNode => {
                    const r = fichaFinanceira.defaultValues?.origem?.referencia as TypeViagem | undefined;
                    if (r == undefined) return <></>;
                    return <>{r.titulo} ({r.destino?.nome}) - Início em {paraData(r.inicio)?.toLocaleDateString()} </>
                })()}
                onClose={() => {
                    navigate(".");
                    setFichaFinanceira({
                        open: false,
                        defaultValues: {} as Titulo<any>,
                    });
                }}
            /> */}

        </div>
    );
};

export default DetalhesDaViagem;
